import { CircularProgress, HStack, Text } from '@chakra-ui/react'
import { useApp } from '@hb/react'
import { colors, ThreadType } from '@hb/shared'
import { useMemo } from 'react'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { ThreadPopover } from '../../../Messaging/ThreadPopover'

export const AssessmentThreadView = ({ mobileView }: { mobileView: boolean }) => {
  const {
    assessmentId,
    selectedAssessment: { populated: selectedAssessment, practiceData },
  } = useProfile()
  const { appName } = useApp()
  const unreadThreadMessages = useMemo(
    () =>
      appName === 'app'
        ? (selectedAssessment?.unreadPregnancyMessages ?? 0)
        : (practiceData?.unreadThreadMessages ?? 0),
    [selectedAssessment, practiceData, appName],
  )
  return assessmentId && selectedAssessment ? (
    <ThreadPopover
      id={assessmentId}
      mobileView={mobileView}
      threadType={ThreadType.ASSESSMENT}
      unreadThreadMessages={unreadThreadMessages}
    />
  ) : (
    <HStack>
      <CircularProgress color={colors.green.hex} isIndeterminate size={4} />
      {mobileView ? null : (
        <Text fontSize="sm" color="gray.500">
          Loading assessment thread...
        </Text>
      )}
    </HStack>
  )
}
